
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import MenuItem from "./MenuItem.vue";
import { PaginaCustomEnum } from "../utils";

const Auth = namespace("Auth");
const AppbarState = namespace("Appbar");
const AppConfigStore = namespace("AppConfig");

@Component({
  name: "MainDrawer",
  components: {
    MenuItem,
  },
})
export default class MainDrawer extends Vue {
  private clicked = 0;

  @Auth.Getter
  private isLoggedIn!: boolean;

  @Auth.Getter
  private isUserAdmin!: boolean;

  @AppbarState.Getter
  private getAppbarStatus!: any;

  @AppConfigStore.Getter
  private getListaPaginasCustom!: any;

  get staticPrimaryMenuItems() {
    return [
      {
        icon: "home",
        title: "Início",
        link: "/home",
        tooltip: "Voltar para a página principal",
      },
    ];
  }

  get staticMenuItems() {
    return [
      {
        icon: "mdi-package-variant-closed",
        title: "Produtos",
        link: "/produtos",
        tooltip: "Buscar produtos",
      },
    ];
  }

  get adminMenuItems() {
    return [
      {
        icon: "mdi-account-tie",
        title: "Administrar",
        link: "/administrar",
        tooltip: "Administrar a aplicação",
      },
    ];
  }

  menuItemIconMap = {
    [PaginaCustomEnum.CONTATO]: {
      icon: "mdi-card-account-phone",
      tooltip: "Dados de contato da empresa",
    },
    [PaginaCustomEnum.EMPRESA]: { icon: "mdi-book-open-variant", tooltip: "Sobre a empresa" },
  };

  normalizeMenuItemIcon(menuItemData: any) {
    const icon = this.menuItemIconMap[menuItemData.tipoPagina]?.icon || menuItemData.icone;

    if (!icon) {
      return "mdi-help-circle-outline";
    }

    if (!icon.startsWith("mdi-")) {
      return `mdi-${icon}`;
    }
    return icon;
  }

  normalizeTooltip(menuItemData: any) {
    return (
      this.menuItemIconMap[menuItemData.tipoPagina]?.tooltip ||
      `Visualizar página de ${menuItemData.nome}`
    );
  }

  navigateToCustom(pageName: string) {
    const parsedPageName = pageName.replaceAll(" ", "_").toLowerCase();
    if (this.$router.currentRoute.path !== `/paginas/${parsedPageName}`)
      this.$router.push({
        name: "PaginaCustom",
        params: {
          name: parsedPageName,
        },
      });
  }

  onCloseDrawer() {
    this.getAppbarStatus.drawer = !this.getAppbarStatus.drawer;
  }
}
